<template>
  <div>
    <!-- Mobile -->
    <div class="news-swiper-mobile">
      <div v-if="item.slide.length" class="p-top-6 p-bot-6 hide-for-large">
        <WidgetSliderSwiper
          :length="allRiferimentoNews.length"
          :title="item.sectionTitle"
          :text="item.text"
        >
          <template
            v-for="(slide, index) in allRiferimentoNews"
            :key="index"
            #[`slide-${index}`]
          >
            <PagesNewsNewsSectionNewsSlide :item="slide" />
          </template>
        </WidgetSliderSwiper>
        <div
          v-if="
            item.mostraBottoneCarosello && item.mostraBottoneCarosello.length
          "
          class="m-top-8 flex --justify-center"
        >
          <nuxt-link
            class="round-icon-btn"
            :to="localePath(item.mostraBottoneCarosello[0].linkDefault)"
          >
            <span
              class="text-medium5 is-medium-bold"
              v-html="item.mostraBottoneCarosello[0].label"
            />
          </nuxt-link>
        </div>
      </div>
    </div>

    <!-- Desktop -->
    <div
      v-if="item.slide.length"
      class="news-section-container row-1 show-for-large p-top-6 p-bot-6"
    >
      <div class="news-section-wrap">
        <div
          v-for="(news, index) in allRiferimentoNews"
          :key="index"
          class="content-block news-section"
        >
          <div class="content-block__text">
            <div
              v-if="news?.title"
              class="content-block__title title-base5 is-medium-bold"
            >
              <p v-html="news.title" />
            </div>
            <div
              v-if="news?.introNews?.html"
              class="content-block__description text-medium5"
            >
              <div v-html="news.introNews.html" />
            </div>
          </div>
          <div>
            <NuxtLink
              :to="
                localePath({
                  name: 'news-slug',
                  params: { slug: news.slug },
                })
              "
            >
              <div class="text-medium5 default-icon-btn is-medium-bold">
                <span>{{ $t('common.approfondisci') }}</span>
                <ArrowIcon alt="Arrow icon" class="icon-arrow" />
              </div>
            </NuxtLink>
          </div>
        </div>
      </div>
      <div
        v-if="item.mostraBottoneCarosello && item.mostraBottoneCarosello.length"
        class="m-top-8 flex --justify-center"
      >
        <nuxt-link
          class="round-icon-btn"
          :to="localePath(item.mostraBottoneCarosello[0].linkDefault)"
        >
          <span
            class="text-medium5 is-medium-bold"
            v-html="item.mostraBottoneCarosello[0].label"
          />
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import ArrowIcon from '@/assets/img/ico/arrow-mobile.svg'

const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
})

const allRiferimentoNews = computed(() => {
  return props.item.slide.reduce((acc, block) => {
    if (block.riferimentoNews && block.riferimentoNews.length) {
      acc.push(...block.riferimentoNews)
    }
    return acc
  }, [])
})
</script>

<script>
export default {
  name: 'NewsSection',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
